import { $axios, $contentHubAxios, API_URL } from "./axios.instance";

const getApiCall = async (endPoint: string, params: string) => {
  try {
    const response = await $axios.get(endPoint + params);
    return response;
  } catch (error: any) {
    return error?.response;
  }
};

const postApiCall = async (endPoint: string, data: any, params: any) => {
  try {
    const response = await $axios.post(API_URL + endPoint + params, data);
    return response;
  } catch (error: any) {
    return error?.response;
  }
};

const loginApiCall = async (
  endPoint: string,
  data: { emailOrUserName: string; password: string }
) => {
  try {
    const config = { headers: { "Content-Type": "application/json" } };

    const response = await $axios.post(endPoint, data, config);
    return response;
  } catch (error: any) {
    return error?.response;
  }
};

const putApiCall = async (endPoint: string, data: any, params: any) => {
  try {
    const response = await $axios.put(API_URL + endPoint + params, data);
    return response;
  } catch (error: any) {
    return error?.response;
  }
};

const patchApiCall = async (endPoint: string, data: any, params: any) => {
  try {
    const response = await $axios.patch(API_URL + endPoint + params, data);
    return response;
  } catch (error: any) {
    return error?.response;
  }
};

const deleteApiCall = async (endPoint: string, params: any) => {
  try {
    const response = await $axios.delete(API_URL + endPoint + params, {});
    return response;
  } catch (error: any) {
    return error?.response;
  }
};

const postApiCallCentral = async (
  endPoint: string,
  data: any,
  params: string = ""
) => {
  try {
    const response = await $contentHubAxios.post(endPoint + params, data);
    return response;
  } catch (error: any) {
    return error?.response;
  }
};

export {
  getApiCall,
  postApiCall,
  postApiCallCentral,
  putApiCall,
  patchApiCall,
  deleteApiCall,
  loginApiCall,
};
